import gsap from "gsap";

document.addEventListener("DOMContentLoaded", () => {
  const formWrapper = document.querySelector(".transport-booking-form");

  if (formWrapper) {
    const list = formWrapper.querySelectorAll(".list-item");
    const inputName = formWrapper.querySelector('input[name="Area"]');

    const buttonSend = formWrapper.querySelector(".button-send");

    if (buttonSend) {
      buttonSend.addEventListener("click", () => {
        const area = formWrapper.querySelector(".area-pickup");
        const date = formWrapper.querySelector(".date-pickup");
        const errorNote = formWrapper.querySelector(".error-note");

        errorNote.innerHTML = "";
        if (area && !area.value) {
          errorNote.innerHTML = "Please select your drop/pickup area!";
          return;
        }

        if (date && !date.value) {
          errorNote.innerHTML = "Date is required!";
          return;
        }
      });
    }

    list.forEach((item) => {
      item.addEventListener("click", () => {
        list.forEach((l) => {
          l.classList.remove("active");
        });

        item.classList.add("active");
        inputName.value = item.dataset?.name;
      });
    });
  }
});
